import { useEffect, useState } from "react";
import type { ReactNode } from "react";
import { keyFingerprint } from "../../lib/fingerprint.js";

/** A public key's fingerprint; admins and users compare it to spot a swapped instance recovery key. */
export function Fingerprint(props: { readonly publicKeyB64: string }): ReactNode {
  const [value, setValue] = useState<string | undefined>(undefined);
  useEffect((): (() => void) => {
    let live = true;
    void keyFingerprint(props.publicKeyB64).then((fp: string): void => {
      if (live) {
        setValue(fp);
      }
    });
    return (): void => {
      live = false;
    };
  }, [props.publicKeyB64]);
  return <span className="font-mono text-[0.8125rem] tracking-wide text-foam">{value ?? "…"}</span>;
}
